module.exports = __webpack_public_path__ + "img/7.b48a47a2.png";